import {
  SET_USER_GROUPS,
  ADD_NEW_USER_GROUP,
  REPLACE_USER_GROUP,
  SET_EXISTING_MANAGER_USERS,
  REMOVE_EXISTING_MANAGER_USER
} from './mutationTypes';

import { setActionStatusPending, setActionStatusSuccess, setActionStatusError } from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_USER_GROUPS](state, userGroups) {
    state.userGroups = userGroups;
  },
  [ADD_NEW_USER_GROUP](state, userGroup) {
    state.userGroups = [userGroup, ...state.userGroups];
  },
  [REPLACE_USER_GROUP](state, userGroup) {
    const index = state.userGroups.findIndex(u => u.id == userGroup.id);
    if (index >= 0) {
      state.userGroups.splice(index, 1, userGroup);
    }
  },
  [SET_EXISTING_MANAGER_USERS](state, users) {
    state.existingAccountUsers = users;
  },
  [REMOVE_EXISTING_MANAGER_USER](state, deletedUserId) {
    state.existingAccountUsers = state.existingAccountUsers.filter(u => u.id != deletedUserId);
  }
};